import { Role } from "../../data/models.interface"
import useLazyQuery from "../useLazyQuery"

export const useUpdateRoleQuery = (roleId: string) => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/roles/${roleId}`
	return useLazyQuery<Role, void>(url, "PATCH")
}
